import AlertIcon from './AlertIcon';
export default AlertIcon;
